var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-page-not-found"},[_c('div',{staticClass:"pt-page-not-found__inner"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pt-page-not-found__inner__text"},[_vm._v(_vm._s(_vm.text || _vm.$t('snapBusiness.pageNotFound')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-page-not-found__inner__img"},[_c('img',{attrs:{"src":require("../assets/images/page-not-found.png")}})])
}]

export { render, staticRenderFns }